import { Button } from '@mui/material';
import { useTheme } from '@mui/styles';
import { AddTransparent } from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { IAddItemButtonProps } from './types';

export default function AddItemButtonComponent(props: IAddItemButtonProps) {
    const { id, text, onClick } = props;
    const classes = muiStyles(props);
    const theme = useTheme<typeof muiTheme>();

    return (
        <Button
            className={classes.addButton}
            id={id}
            onClick={onClick}
        >
            <AddTransparent
                className={classes.buttonIcon}
                iconColor={theme?.app?.clientTheme.colors.primaryColorLight || '#009BDF'}
            />
            <span className={classes.buttonText}>{text}</span>
        </Button>
    );
}